import React from 'react';
import ContextMenuWrapper from './common/ContextMenuWrapper.jsx'

class StdDeviationsContextMenu extends React.Component {

    constructor (props)  {
        super(props)
        this.state = {
            noOfStdDev: this.props.noOfStdDev
        }
    }
    
    handleChange = (e) => {
        e.stopPropagation();
        let val = parseInt(e.target.value);
        if(val > 1 && !e.target.checked && this.state.noOfStdDev <= val ) {
            val--;
        }
        this.setState({
            noOfStdDev: val
        }, () => {
            this.props.handleChange(this.state.noOfStdDev);
        });
    }

    getLoc = (str) => {
        let Dyn = this.props.Dyn;
          return Dyn.loc( str );
    }

    render = () => {
        return (
            <ContextMenuWrapper {...this.props} isColorPickerEnable = {true}>
                <ContextMenuWrapper.Options>
                    <div className={`tde-p-2 tde-std-dev-option ${this.state.noOfStdDev === 1 ? 'active': null}`} >
                        <label className="tde-d-flex tde-flex-items-center"><input id="tde-std-dev-1" className="tde-radio" autoFocus type="radio" checked={this.state.noOfStdDev === 1} name="noofstd" value="1" onChange={this.handleChange} /> { this.getLoc('1 Standard Deviation') } </label>
                    </div>
                    <div className={`tde-p-2 tde-std-dev-option ${this.state.noOfStdDev === 2 ? 'active': null}`}>
                        <label className="tde-d-flex tde-flex-items-center"><input id="tde-std-dev-2" className="tde-radio" type="radio" checked={this.state.noOfStdDev === 2} name="noofstd" value="2" onChange={this.handleChange} /> { this.getLoc('2 Standard Deviations') } </label>
                    </div>
                    <div className={`tde-p-2 tde-std-dev-option ${this.state.noOfStdDev === 3 ? 'active': null}`}>
                        <label className="tde-d-flex tde-flex-items-center"><input id="tde-std-dev-3" className="tde-radio" type="radio" checked={this.state.noOfStdDev === 3} name="noofstd" value="3" onChange={this.handleChange} /> { this.getLoc('3 Standard Deviations') } </label>
                    </div>
                </ContextMenuWrapper.Options>
            </ContextMenuWrapper>
        )
    }
}

export default StdDeviationsContextMenu;
